import {cUtil}                     from '../../../functions/util';
import { cProductItem }            from '../../../components/product-item/product-item';
import {cSingleProductOrderLists}  from './single-product-order-lists';

export class cSingleProductOrderList{

  fieldset     = document.createElement('fieldset');
  div_name     = document.createElement('div');
  button       = document.createElement('button');
  button_small = document.createElement('button'); 


  inputList   : OrderList;
  listId      : string;
  nonce       : string;
  lists       : cSingleProductOrderLists;
  product     : cProductItem;

  constructor(
    list        : OrderList, 
    parent      : HTMLElement, 
    nonce       : string,
    productItem : cProductItem,
    lists       : cSingleProductOrderLists,
    ) {
    
    this.inputList  = list;
    this.listId     = list.list_id === '' ? cUtil.rand() : list.list_id;
    this.nonce      = nonce;
    this.lists      = lists;
    this.product    = productItem;

    // ---- Structure ----
    parent.append(this.fieldset);
      this.fieldset.append(this.div_name);
      this.fieldset.append(this.button);
      this.fieldset.append(this.button_small);

    // ---- Texts ----
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.button.innerText = __('Hinzufügen', 'custom');
    this.div_name.innerText = list.name;

    // ---- Classes ----
    this.button.classList.add('c-button');
    this.button_small.classList.add('c-button-icon');

    // ---- Other ----
    this.button.type               = 'button';
    this.button.dataset.listId     = this.listId;
    this.button.dataset.customerId = list.customer_id;

    // ---- Events ----
    this.button.addEventListener('click', (event) => {
      this.addList();
    });
    this.button_small.addEventListener('click', (event) => {
      this.addList();
    });

  }

  addList() {
    const item       = this.product.getData();
    item.list_id     = this.listId;
    item.customer_id = this.inputList.customer_id;
    this.lists.spinnerOn();
    this.sendItem(item);
    this.lists.close();
    this.lists.spinnerOff();
  }

  async sendItem(data: OrderListItem) {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.nonce);
    formData.append('action'     , 'c_order_list_item_add');
    formData.append('data'       , JSON.stringify(data));

    const error = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
  }
}
